export default __webpack_public_path__ + "static/media/earphones4.0cab5c70.jfif";